<template>
    <div class="table-tools-actions flex justify-center md:justify-end w-full md:w-auto  items-center space-x-2 select-none">
    <!-- <div class="table-tools-actions flex justify-center md:justify-end w-full items-center space-x-2 select-none"> -->
  <!--    <base-input-search  @keydown="actionSearch" v-model="search" name="search" size="xs" type="text" @manualSearch="manualSearch" /> -->
      <base-button-responsive @click="toggleFilters" icon="filter" size="xs" class="w-full md:w-auto" :text="$tc('app.filter', 2)" :disabled="disabled"></base-button-responsive>
    </div>
</template>

<script>
export default {
  name: 'base-table-search',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      search: ''
    }
  },
  computed: {
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
  },
  methods: {
    toggleFilters: function () {
      this.$emit('toggleFilters')
    },
    actionSearch: function () {
      // busqueda según escribe
    },
    manualSearch: function (val) {
      // busqueda tras enter o pulsar el botón de buscar del input
    }
  }
}
</script>

<style scoped>
  @media (width < 1550px)
  {
    .table-tools-actions {
      flex-direction: row;
    }
  }
</style>
